import script from "./UserLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./UserLayout.vue?vue&type=script&setup=true&lang=js"

import "./UserLayout.vue?vue&type=style&index=0&id=064b0ab4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-064b0ab4"]])

export default __exports__